<div class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered"
       [ngClass]="dialogClass && dialogClass.length > 0 ? dialogClass : 'modal-dialog-xs'">
    <div class="modal-content">
      <div class="modal-header">
        <h3 [class]="titleClass">{{ title }}</h3>
        <button *ngIf="hasClose"
                type="button"
                class="btn-close"
                (click)="closeModal(false)"
                aria-label="Close">&times;</button>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>

        <div *ngIf="!isValid && submited" class="error-label" role="alert">
          {{
            (errorMessage != null && errorMessage.length > 0)
              ? errorMessage
              : ('common.requiredFields' | translate)
          }}
        </div>
      </div>

      <div [class]="'modal-footer ' + footerClass">

        <div *ngIf="extraButtons != null"
             style="margin-bottom: 4px; width: 100%; display: flex; flex-direction: column;">
          <button *ngFor="let btn of extraButtons"
                  type="button"
                  class="btn"
                  [ngClass]="{
                    'btn-remove': btn.color == 'danger',
                    'btn-transparent-outline': btn.color == 'default',
                    'btn-sec': btn.color == 'sec'
                  }"
                  (click)="btn.action(btn)">
            {{ btn.name }}
          </button>
        </div>

        <button *ngIf="hasCancel" type="button" class="btn btn-faded" (click)="closeModal(false)">
          {{ cancelText }}
        </button>

        <button *ngIf="hasOk" type="button" class="btn btn-main" (click)="closeModal(true)">
          {{ okText }}
        </button>

      </div>
    </div>
  </div>
</div>